import React from 'react';
import { CompetitionsForms } from '@johnlewispartnership/wtr-content-component-library';
import submitFormAction from 'redux/modules/competitions/actions/submit-form';
import { useWtrDispatch, useWtrSelector } from 'redux/hooks';
import { isUserLoggedIn } from 'redux/modules/sessions/selectors';
import { getMembershipCardNumber } from 'redux/modules/marketing-preferences/selectors/get-membership-status';
import { getContactAddress } from 'redux/modules/address/selectors';
import { getCustomerEmail } from 'redux/modules/accounts/selectors/get-customer-account';
import { getFeatureFlags } from 'utils/feature-flags';
import ReCaptchaHOC from 'components/CompetitionsForms/ReCaptchaHoC';

type CompetitionsFormsWrapperProps = {
  competitionEndDate: string;
  competitionId: string;
  competitionName: string;
  competitionQuestion: string;
  competitionStatus: string;
  competitionType: string;
  breakpointClasses: string[];
  questionAndOptions: {
    question: string;
    options: string[];
  };
  optIns: any;
  useGoogleReCaptcha: (...args: any[]) => any;
};

const CompetitionsFormsWrapper = (props: CompetitionsFormsWrapperProps) => {
  const dispatch = useWtrDispatch();
  const onFormSubmit = async (...submitProps: any[]) => dispatch(submitFormAction(...submitProps));

  const competitionsSingleClickEntry = getFeatureFlags()?.loyalty_competitiononeclickentry;
  const userIsLoggedIn = useWtrSelector(isUserLoggedIn);
  const membershipCardNumber = useWtrSelector(getMembershipCardNumber);
  const contactAddress = useWtrSelector(getContactAddress);
  const emailAddress = useWtrSelector(getCustomerEmail);

  const formProps = {
    competitionsSingleClickEntry,
    userIsLoggedIn,
    membershipCardNumber,
    contactAddress,
    emailAddress,
    onFormSubmit,
    ...props,
  };

  return <CompetitionsForms {...formProps} />;
};

export default ReCaptchaHOC(CompetitionsFormsWrapper);
